// Add Edit Contact form
export const CONFIG = {
  tablePG: [50, 100, { text: "All", value: -1 }],
};

export const GENDERS = ["male", "female", "other"];
export const BUSINESS_TYPES = ["client", "loan", "employee", "purchase"];
export const CONTACT_TYPES = ["individual", "company"];
export const NAV_MENU_REPORTS = {
  icon: "bar_chart",
  title: "Reports",
  router_name: "daily_expense_report",
  perm: ["sadmin","admin"],
  items: [
    {
      icon: "arrow_circle_up",
      title: "Invoice Report",
      router_name: "invoice_report",
      perm: ["sadmin","admin"],
    },
    {
      icon: "arrow_circle_up",
      title: "Company Report",
      router_name: "company_report",
      perm: ["sadmin","admin"],
    },
    {
      icon: "arrow_circle_up",
      title: "Due Report",
      router_name: "due_invoice_report",
      perm: ["sadmin","admin"],
    },
    {
      icon: "dynamic_feed",
      title: "Expense Report",
      router_name: "expense_report",
      perm: ["sadmin","admin"],
    },
    // {
    //   icon: "arrow_circle_up",
    //   title: "Daily Received",
    //   router_name: "daily_received_report",
    //   perm: ["sadmin","admin"],
    // },
    // {
    //   icon: "dynamic_feed",
    //   title: "Dues Report",
    //   router_name: "invoice_dues_report",
    //   perm: ["sadmin","admin"],
    // },
    // {
    //   icon: "arrow_circle_up",
    //   title: "Bill Dues",
    //   router_name: "bill_dues_report",
    //   perm: ["sadmin","admin"],
    // },
    // {
    //   icon: "arrow_circle_up",
    //   title: "Loan Dues",
    //   router_name: "loan_dues_report",
    //   perm: ["sadmin","admin"],
    // },
    // {
    //   icon: "arrow_circle_up",
    //   title: "Profit & Loss",
    //   router_name: "monthly_profit_loss",
    //   perm: ["sadmin","admin"],
    // },
    // {
    //   icon: "arrow_circle_up",
    //   title: "Projects Report",
    //   router_name: "projects_report",
    //   perm: ["sadmin","admin"],
    // },
    // {
    //   icon: "arrow_circle_up",
    //   title: "Cash Inflows",
    //   router_name: "monthly_cash_inflows",
    //   perm: ["sadmin","admin"],
    // },
    // {
    //   icon: "arrow_circle_up",
    //   title: "Cash Outflows",
    //   router_name: "monthly_cash_outflows",
    //   perm: ["sadmin","admin"],
    // },
  ],
};

export const DAY_NAMES = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const MYSQL_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const MYSQL_DATE_FORMAT = "YYYY-MM-DD";
export const MYSQL_TIME_FORMAT = "HH:mm:ss";
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "hh:mm a";

// Manpower start

// export const MEDICAL_STATUSES = [
//   { value: "in_office", text: "Submmit in Office" },
//   { value: "in_medical", text: "Submmit In Medical" },
//   { value: "fit", text: "Fit" },
//   { value: "unfit", text: "Unfit" }
// ];
// export const VISA_TYPES = [
//   {text: "LABOUR", value: "labour"},
//   {text: "FACTORY WORKER", value: "factory_worker"},
//   {text: "CLEANING WORKER", value: "cleaning_worker"},
//   {text: "SCAFFOLDER", value: "scaffolder"},
//   {text: "SCAFFOLDER", value: "scaffolder"},
//   {text: "MASON", value: "mason"},
//   {text: "CONTRACT LABOUR", value: "contract_labour"},
//   {text: "KITCHEN CLEANER", value: "kitchen_cleaner"},
//   {text: "S/FIXER", value: "s_fixer"},
// ];


// export const SERVICE_TYPES = [
//   {text: "VISA PROCESSING", value: "processing"},
//   {text: "VISA WORKING", value: "working"},
// ];

export const PAYMENT_METHODS = ["cash", "cheque", "other"];

// export const PROJECT_OWNER = [
//   {text: "HABIB", value: "habib"},
//   {text: "IDM", value: "idm"}
// ];


// Manpower end

// Simple Invoicing Start

export const SYS_CURRENCY = "SAR";

// Simple Invoicing end

